import r from"./_baseFor.js";import o from"./keys.js";var t=r,a=o;var e=function(r,o){return r&&t(r,o,a)};export{e as default};
//# sourceMappingURL=_baseForOwn.js.map
